import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import { Div, Loading, P } from 'konsys-ui'
import { CREATE_RECEIVER, UPDATE_RECEIVER } from '../../../constants/graphql/mutation'
import { GET_RECEIVER } from '../../../constants/graphql/query'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { ActionBar } from '../../../components/destination-components'

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW

  const [mutationVariables, setMutationVariables] = useState(
    isAddMode && {
      type: 'CLIENT',
      credit: '30',
    },
  )

  let onChangeHandler = (id, value) => {
    setMutationVariables({
      typeOfChargeId: 1,
      ...mutationVariables,
      [id]: value,
    })
  }

  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      {
        isAddMode
          ? detailType(props.match.params, onChangeHandler, mutationVariables)
          : isViewMode
            ? <Query
                query={GET_RECEIVER}
                variables={{ id: props.match.params.id }}
              >{({ data, error, loading }) => {
                if (loading && _.isEmpty(data)) return <Loading center='true' />
                if (error) return <P>เกิดข้อผิดพลาด</P>
                return detailType(props.match.params, onChangeHandler, mutationVariables, data.ReceiverLocationInfo) // argument mode
              }}
              </Query>
            : <Query
                query={GET_RECEIVER}
                variables={{ id: props.match.params.id }}
              >{({ data, error, loading }) => {
                if (loading && _.isEmpty(data)) return <Loading center='true' />
                if (error) return <P>เกิดข้อผิดพลาด</P>
                onChangeHandler = (id, value) => {
                  setMutationVariables({
                    id: data.ReceiverLocationInfo.id,
                    name: data.ReceiverLocationInfo.name,
                    branch: data.ReceiverLocationInfo.branch,
                    address: data.ReceiverLocationInfo.address,
                    ...mutationVariables,
                    [id]: value,
                  })
                }
                return detailType(props.match.params, onChangeHandler, mutationVariables, data.ReceiverLocationInfo) // argument mode
              }}
              </Query>
      }
      {/* ================== Footer section ================== */}
      {
        !isViewMode
          ? <Mutation
              mutation={isAddMode ? CREATE_RECEIVER : UPDATE_RECEIVER}
            >{(doAction, { loading }) => (
              <ActionBar
                loading={loading}
                disabled={_.isUndefined(mutationVariables.name) || _.isEmpty(mutationVariables.name)}
                isAddMode={isAddMode}
                isViewMode={isViewMode}
                doAction={doAction}
                mutationVariables={mutationVariables}
                props={props}
              />
            )}
            </Mutation>
          : <ActionBar
              isAddMode={isAddMode}
              isViewMode={isViewMode}
              props={props}
            />
      }
    </Div>
  )
}

export default Index
export { Index }
